import { PrimaryButton, Reveal } from "@/components/ui-bits";
import { ServiceTag, CapList, ImageFrame } from "@/pages/services/bits";

const CAPABILITIES = [
  "FULL TRUCKLOAD TRANSPORTATION",
  "PARTIAL LOADS",
  "PALLETIZED FREIGHT",
  "COMMERCIAL FREIGHT",
  "DRY VAN TRANSPORTATION",
  "RECURRING SHIPMENTS",
];

const ServiceFTL = () => {
  return (
    <section id="ftl-partial-loads" data-testid="service-ftl" aria-labelledby="ftl-heading" className="scroll-mt-24 bg-white pb-16 pt-8 sm:pb-20 sm:pt-10 lg:pb-24 lg:pt-12">
      <div className="container-30 grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <ImageFrame
            src="/assets/ftl-loading.webp"
            alt="Palletized freight being loaded into a 30 NORTH dry van trailer at an Ontario warehouse loading dock"
            testid="ftl-image"
            caption={<>PALLETIZED FREIGHT <span className="ml-2 text-[#ff6a00]">DRY VAN</span></>}
          />
        </Reveal>
        <Reveal delay={0.1}>
          <ServiceTag number="01" label="Freight Transportation" />
          <h2 id="ftl-heading" data-testid="ftl-headline" className="mt-6 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl">
            FTL & PARTIAL LOADS
          </h2>
          <p className="mt-3 font-display text-lg font-semibold text-[#191c1e]/80">Flexible transportation for commercial freight.</p>
          <p className="mt-5 text-base leading-relaxed text-[#5f666d]">
            Whether you are moving a full truckload or only need space for part of a truck, 30 NORTH provides
            transportation solutions based on your shipment size, schedule and delivery requirements.
          </p>
          <div className="mt-8">
            <CapList items={CAPABILITIES} testid="ftl-capabilities" />
          </div>
          <div className="mt-10">
            <PrimaryButton to="/request-a-quote" testid="ftl-cta">
              REQUEST A QUOTE
            </PrimaryButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ServiceFTL;
